/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessingStatusQueryResponse, DocumentUseCasesControllerGetProcessingStatusPathParams, DocumentUseCasesControllerGetProcessingStatus400, DocumentUseCasesControllerGetProcessingStatus401, DocumentUseCasesControllerGetProcessingStatus403, DocumentUseCasesControllerGetProcessingStatus404 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessingStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetProcessingStatus } from "../../clients/document-use-casesService/documentUseCasesControllerGetProcessingStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetProcessingStatusQueryKey = (id: DocumentUseCasesControllerGetProcessingStatusPathParams["id"]) => [{
  url: '/api/v1/documents/:id/processing-status',
  params: {
    id: id
  }
}] as const;
export type DocumentUseCasesControllerGetProcessingStatusQueryKey = ReturnType<typeof documentUseCasesControllerGetProcessingStatusQueryKey>;
export function documentUseCasesControllerGetProcessingStatusQueryOptions(id: DocumentUseCasesControllerGetProcessingStatusPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetProcessingStatusQueryKey(id);
  return queryOptions<DocumentUseCasesControllerGetProcessingStatusQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingStatus400 | DocumentUseCasesControllerGetProcessingStatus401 | DocumentUseCasesControllerGetProcessingStatus403 | DocumentUseCasesControllerGetProcessingStatus404>, DocumentUseCasesControllerGetProcessingStatusQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetProcessingStatus(id, config);
    }
  });
}

/**
 * @description Returns current processing status and progress for a document as a read-only resource
 * @summary Get document processing status
 * {@link /api/v1/documents/:id/processing-status}
 */
export function useDocumentUseCasesControllerGetProcessingStatus<TData = DocumentUseCasesControllerGetProcessingStatusQueryResponse, TQueryData = DocumentUseCasesControllerGetProcessingStatusQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetProcessingStatusQueryKey>(id: DocumentUseCasesControllerGetProcessingStatusPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetProcessingStatusQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingStatus400 | DocumentUseCasesControllerGetProcessingStatus401 | DocumentUseCasesControllerGetProcessingStatus403 | DocumentUseCasesControllerGetProcessingStatus404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetProcessingStatusQueryKey(id);
  const query = useQuery({
    ...documentUseCasesControllerGetProcessingStatusQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingStatus400 | DocumentUseCasesControllerGetProcessingStatus401 | DocumentUseCasesControllerGetProcessingStatus403 | DocumentUseCasesControllerGetProcessingStatus404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}